// Reject even when an adapter ignores AbortSignal; its late response cannot commit.
export async function withDeadline<T>(read: (signal: AbortSignal) => Promise<T>, parent: AbortSignal, milliseconds = 15_000): Promise<T> {
  parent.throwIfAborted()
  const controller = new AbortController()
  let rejectAbort!: (reason: unknown) => void
  const aborted = new Promise<never>((_, reject) => { rejectAbort = reject })
  const abort = () => { controller.abort(parent.reason); rejectAbort(parent.reason ?? new DOMException('Aborted', 'AbortError')) }
  if (parent.aborted) abort()
  else parent.addEventListener('abort', abort, { once: true })
  const timer = setTimeout(() => {
    const reason = new DOMException('Request timed out', 'TimeoutError')
    controller.abort(reason)
    rejectAbort(reason)
  }, milliseconds)
  try { return await Promise.race([read(controller.signal), aborted]) }
  finally { clearTimeout(timer); parent.removeEventListener('abort', abort) }
}
